import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { User } from '@shared/models/user';
import { LoadingState } from '@shared/types/loading-state';
import { Observable } from 'rxjs';
import * as fromGroupUsers from '../reducers/group-users.reducer';
import { loadGroupUsers } from '../actions/load-group-users.actions';
import { UserFilters } from '@shared/models/user-filters';

@Injectable({
  providedIn: 'root',
})
export class GroupUsersService {
  constructor(private store: Store) {}

  loadGroupUsers() {
    this.store.dispatch(loadGroupUsers());
  }

  getGroupUsersLoading(): Observable<LoadingState> {
    return this.store.select(fromGroupUsers.selectGroupUsersLoadingState);
  }

  getFilteredGroupUsers(filter: UserFilters): Observable<User[]> {
    return this.store.select(fromGroupUsers.selectFilteredGroupUsers(filter));
  }

  getGroupUserById(userId: string): Observable<User | undefined> {
    return this.store.select(fromGroupUsers.selectGroupUserById(userId));
  }
}
